var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: "top", trigger: "manual", width: "620" },
      model: {
        value: _vm.innerVisible,
        callback: function($$v) {
          _vm.innerVisible = $$v
        },
        expression: "innerVisible"
      }
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.groupRowData } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("CargoMsg.Cargo_Currency"),
              property: "SOURCE_CURRENCY",
              width: "50"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("CargoMsg.Cargo_DebitAmountOccurredSource"),
              property: "DEBIT_USD",
              width: "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("CargoMsg.Cargo_DebitAmountOccurredLocal"),
              property: "DEBIT_RMB",
              width: "140"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("CargoMsg.Cargo_CreditAmountOccurredSource"),
              property: "CREDIT_USD",
              width: "130"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("CargoMsg.Cargo_CreditAmountOccurredLocal"),
              property: "CREDIT_RMB",
              width: "140"
            }
          })
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: {
            color: "deepskyblue",
            cursor: "pointer",
            "padding-left": "5px"
          },
          attrs: { slot: "reference", no: "1" },
          on: { click: _vm.clickHandler },
          slot: "reference"
        },
        [
          _vm._v(" " + _vm._s(_vm.btnLable) + " "),
          _c("i", {
            class: !_vm.innerVisible
              ? "el-icon-caret-left"
              : "el-icon-caret-top"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }